<template>
  <div>
    <v-menu bottom :offset-y="true">
      <template v-slot:activator="{ on, attrs }">
        <div v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
            :size="20"
            :width="4"
            class="ma-2"
          ></v-progress-circular>
        </div>
        <div v-else>
          <div v-if="user && user.email">
            <v-btn v-bind="attrs" v-on="on" large class="ml-2">
              <v-img
                :src="user.photo"
                class="mr-2"
                width="25"
                height="25"
                style="border-radius: 100px"
              ></v-img>
              {{ user.username }}
            </v-btn>
          </div>
          <div v-else>
            <v-btn v-bind="attrs" v-on="on" class="ml-2">
              Login
            </v-btn>
          </div>
        </div>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-title v-if="user && user.email">
            <v-btn text @click="logout">
              Logout
            </v-btn>
          </v-list-item-title>
          <v-list-item-title v-else>
            <v-btn text @click="loginWithGoogle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                aria-hidden="true"
              >
                <title>Google</title>
                <g fill="none" fill-rule="evenodd">
                  <path
                    fill="#4285F4"
                    d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"
                  ></path>
                  <path
                    fill="#34A853"
                    d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"
                  ></path>
                  <path
                    fill="#FBBC05"
                    d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"
                  ></path>
                  <path
                    fill="#EA4335"
                    d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"
                  ></path>
                </g>
              </svg>
              Google
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";
import axios from "axios";

export default {
  name: "TheLogin",
  mixins: [SendRequestMixin],
  components: {},
  data() {
    return {
      loading: true
    };
  },
  computed: {
    user() {
      return this.$store.getters["loginUser"];
    }
  },
  methods: {
    logout() {
      this.$store.commit("mutate", {
        property: "loginUser",
        with: null
      });
    },
    loginWithGoogle() {
      let _vm = this;
      google.accounts.id.prompt((notification) => {
        if ((notification.isNotDisplayed() || notification.isSkippedMoment())) { _vm.logout(); }
        else if ((notification.isDismissedMoment()) && (notification.getDismissedReason() != "credential_returned")) { _vm.logout(); }
      });
    },
    loginWithFacebook() {
      window.FB.login(response => {
        if (response && response.authResponse) {
          console.log("response", response);
          var userInfo = {
            loginType: "fb",
            fb: {
              auth: response.authResponse
            }
          };
          this.$store.commit("setLoginUser", userInfo);
          window.FB.api(
            `/${response.authResponse.userID}`,
            userResponse => {
              if (userResponse) {
                console.log(userResponse);
                var userInfo = {
                  loginType: "fb",
                  fb: {
                    auth: response.authResponse,
                    user: userResponse
                  }
                };
                this.$store.commit("setLoginUser", userInfo);
              }
            },
            this.params
          );
        }
      }, this.params);
    }
  },
  created() {

    const _vm = this;

    window.onGoogleLibraryLoad = () => {
      google.accounts.id.initialize({
        client_id: _vm.$google_client_id,
        callback: (cred) => {
          axios
            .get(`${_vm.$BASE_URL}/login/callback?code=${cred.credential}`)
            .then(user => {
              _vm.$store.commit("mutate", {
                property: "loginUser",
                with: user.data
              });
            })
            .catch(() => {
              _vm.logout();
            });
        }
      });
      _vm.loading = false;
    };


    if (!this.user) return (this.loading = false);

    axios
      .get(this.$BASE_URL + "/status", {
        headers: {
          Authorization: `Bearer ${this.user.token}`
        }
      })
      .then(() => {
        _vm.loading = false;
      })
      .catch(() => {
        _vm.logout();
        _vm.loading = false;
      });
  }
};
</script>
<style lang="sass">
.loginModal
	position: absolute
	right: 0
</style>
